<script lang="ts" setup>
const { t } = useI18n()
</script>

<template>
  <v-app-bar class="banner" height="48" app flat data-cy="banner_update_payment_method">
    <div class="d-flex justify-center flex-grow-1">
      <div class="d-flex align-center">
        <p class="text-body-2 text-danger font-weight-bold">
          {{ t('payment_method_update.could_not_be_charged') }}
        </p>
        <i18n-t
          class="text-body-2 text-black font-weight-bold ml-1"
          tag="span"
          keypath="payment_method_update.update_payment_method.text"
        >
          <template #link>
            <nuxt-link class="text-black" href="/plan">{{
              t('payment_method_update.update_payment_method.link_text')
            }}</nuxt-link>
          </template>
        </i18n-t>
      </div>
    </div>
  </v-app-bar>
</template>

<style lang="scss" scoped>
.banner {
  background-color: rgba(227, 13, 68, 0.15);
}
</style>
